// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/home/styles/jumping-man.scss
// module id = 1481
// module chunks = 0